module.exports = __webpack_public_path__ + "img/brand--jokr.2af187e3.png";